import * as React from "react";
import styled from "styled-components";
import { VerticalSpacer } from "../Spacers";
import { theme } from "../../../theme";
import SmallLoadingSpinner from "../SmallLoadingSpinner";
import "@fontsource/inter";

interface Props {
  onClick?: (props?: any) => void;
  disabled?: boolean;
  title: string;
  color?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  iconRight?: React.ReactNode;
  fullwidth?: boolean;
  loading?: boolean;
  small?: boolean;
}

const ButtonContainer = styled.button<{
  color: string;
  disabled?: boolean;
  fullwidth?: boolean;
  small?: boolean;
}>`
  background-color: ${(props) => props.color};
  border-radius: 4px;
  padding: ${(props) => (props.small ? "4px 16px" : "12px 16px")};
  color: ${(props) =>
    props.color === theme.colors.warning
      ? theme.colors.text
      : theme.colors.white};
  font-size: ${(props) => (props.small ? "14px" : "16px")};
  font-weight: 400;
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  width: ${(props) => (props.fullwidth ? "100%" : "auto")};
  height: ${(props) => (props.small ? "24px" : "36px")};

  &:hover {
    filter: ${(props) => !props.disabled && "opacity(0.6)"};
    box-shadow: ${(props) =>
      !props.disabled && "0px 4px 6px rgba(0, 0, 0, 0.1)"};
  }

  &:active {
    filter: opacity(1);
    box-shadow: none;
  }

  &:disabled {
    background-color: ${() => theme.colors.disabled};
    color: ${() => theme.colors.white};
  }
`;

const ActionButton: React.FC<Props> = ({
  onClick,
  disabled,
  title,
  color = theme.colors.warning,
  icon,
  type,
  iconRight,
  fullwidth,
  loading,
  small,
}) => {
  return (
    <ButtonContainer
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      fullwidth={fullwidth}
      small={small}
    >
      {icon && (
        <>
          {icon} <VerticalSpacer spacing={0.5} />
        </>
      )}

      {loading ? <SmallLoadingSpinner color="white" /> : title}

      {iconRight && (
        <>
          <VerticalSpacer spacing={0.5} />
          {iconRight}
        </>
      )}
    </ButtonContainer>
  );
};

export default ActionButton;
